import React from 'react';
import { useConsent } from './ConsentContext';

// WP-3.1 — minimal first-party consent banner.
//
// DARK BY DEFAULT: renders nothing unless VITE_CONSENT_ENABLED === 'true'
// (consentEnabled) AND the user has not yet decided. UI chrome only — deterministic
// static FR copy, NOT indexable SEO content; emits no metadata and does not alter
// page content (ADR-0007 §12.8 / WP-3 §3 CA3). Prerender-safe (pure render).
//
// Consent withdrawal is exposed via the context (resetConsent); a persistent
// re-open control can be wired into the footer in a later step without touching
// this component.
export default function ConsentBanner() {
  const { consentEnabled, decided, grantAnalytics, denyAnalytics } = useConsent();

  if (!consentEnabled || decided) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Gestion du consentement"
      className="fixed bottom-0 inset-x-0 z-50 border-t border-white/10 bg-black/90 backdrop-blur px-4 py-4 sm:px-6"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-white/70">
          Nous utilisons des mesures d’audience pour améliorer le site. Aucune mesure n’est activée
          sans votre accord.{' '}
          <a href="/confidentialite" className="underline hover:text-white">
            Confidentialité
          </a>
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={denyAnalytics}
            className="rounded-md border border-white/20 px-4 py-2 text-sm text-white/80 hover:bg-white/5"
          >
            Refuser
          </button>
          <button
            type="button"
            onClick={grantAnalytics}
            className="rounded-md bg-white px-4 py-2 text-sm font-medium text-black hover:bg-white/90"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
